import { type ReactElement } from 'react'
import { Page } from '@components'
import { Grid, Divider } from '@mantine/core'
import { ProgramPageContainer } from '../program/ProgramPageContainer'
import { ProgramHeading } from '../program_.$programId/ProgramHeader'
import { useProgramContext } from '../program_.$programId/context'
import { ProgramAuditInfo } from './ProgramAuditInfo'
import { ProgramBasicInfo } from './ProgramBasicInfo'
import { createFileRoute } from '@tanstack/react-router'

function ProgramSummary(): ReactElement {
  const { program } = useProgramContext()
  return (
    <ProgramPageContainer>
      <ProgramHeading title='Program' />
      <Page.Content scrollArea>
        <Grid>
          <Grid.Col span={{ base: 12, xl: 6 }}>
            <ProgramBasicInfo program={program} />
          </Grid.Col>
          <Divider orientation='vertical' />
          <Grid.Col span={{ base: 12, xl: 'auto' }}>
            <ProgramAuditInfo program={program} />
          </Grid.Col>
        </Grid>
      </Page.Content>
    </ProgramPageContainer>
  )
}

export const Route = createFileRoute('/program_/$programId/summary/')({
  component: ProgramSummary,
})
